export default Object.freeze({
  USER_NORMAL: "UserNormal",
  USER_NORMAL_PRO: "UserNormalPro",
  USER_FRANQUICIA: "UserFranquicia",
  USER_FRANQUICIADO: "UserFranquiciado",
  USER_FRANQUICIA_PRO: "UserFranquiciaPro",
  USER_FRANQUICIADO_PRO: "UserFranquiciadoPro",
  USER_EMPLOYEE: "UserEmployee",
  USER_EMPLOYEE_PRO: "UserEmployeePro",
  USER_ADMIN: "UserAdmin",
  GLOBAL_ADMIN: "Administrador",
  USER_PAYMENT: "UserPayment",
  USER_NOT_PAYMENT: "UserNotPayment",
  USER_DISTRIBUTOR: "UserDistributor",

  USER_CAN_EDIT_LICENCES: "USER_CAN_EDIT_LICENCES",
  USER_CAN_CREATE_LICENCES: "USER_CAN_CREATE_LICENCES",
  USER_CAN_DELETE_LICENCES: "USER_CAN_DELETE_LICENCES",
  USER_CAN_DUPLICATE_LICENCES: "USER_CAN_DUPLICATE_LICENCES",
});
